import { render, staticRenderFns } from "./TenancyRateDetails.vue?vue&type=template&id=163f5ca3"
import script from "./TenancyRateDetails.vue?vue&type=script&lang=js"
export * from "./TenancyRateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports